export enum ModaleAnnulerResultatEnum {
  Annuler,
  Fermer
}
